import { render, staticRenderFns } from "./relungku-view.vue?vue&type=template&id=51353413&scoped=true&"
import script from "./relungku-view.vue?vue&type=script&lang=js&"
export * from "./relungku-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51353413",
  null
  
)

export default component.exports